import React from "react";
import Input from "Components/input/Input";
import Button from "Components/button/Button";
import PasswordGenerator from "Components/PasswordGenerator";
import QboxmailApi from "../../../qboxmailApi";
import t from "Utils/translation";
import CustomerSelect from "Components/customerSelect/CustomerSelect";
import cx from "classnames";
import { Icon, warningFill } from "Icons/index";

export default class Step1 extends React.Component {
  constructor(props) {
    super(props);
    this.validate = this.validate.bind(this);
    this.goToNextStep = this.goToNextStep.bind(this);
    this.setCustomerCode = this.setCustomerCode.bind(this);
    this.submit = this.submit.bind(this);
    this.fillPasswordFields = this.fillPasswordFields.bind(this);
    this.state = {};
  }

  componentDidMount() {
    // this.firstInput.focus();
  }

  submit(e) {
    e.preventDefault();
    this.props.submitForm();
  }

  goToNextStep(e) {
    const { setFormLoading, setFormErrors, setDataForm, goToStep, formData } = this.props;

    e.preventDefault();
    setFormLoading();

    this.validate(formData).then((errors) => {
      if (Object.keys(errors).length > 0) {
        setFormErrors(errors);
      } else {
        setDataForm(formData);
        goToStep(2);
      }
    });
  }

  validate({ email_address }) {
    return new Promise((resolve) => {
      let errors = {};

      if (this.props.isLoggedUserAdmin && !this.props.formData.customer_code) {
        errors.customer_code = "is missing";
        resolve(errors);
        return;
      }

      const api = new QboxmailApi({ useCookie: true });
      api
        .validateTeamMemberEmail(email_address)
        .then((response) => {
          if (response.valid) {
            resolve(errors);
          } else {
            errors.email_address = response.message;
            resolve(errors);
          }
        })
        .catch(() => {
          errors.name = "is not valid";
          resolve(errors);
        });
    });
  }

  fillPasswordFields(generatedPassword) {
    this.props.setFormFieldValue({
      password: generatedPassword,
      password_confirmation: generatedPassword,
    });
  }

  setCustomerCode(data) {
    this.props.setFormFieldValue({
      customer_code: data.value,
    });
  }

  render() {
    const { formData, setFormFieldValue, formErrors, isFormLoading, isLoggedUserAdmin } = this.props;

    return (
      <div className="formsPage">
        {this.props.stepper}

        <div className={cx("sectionTitle", "titleFP")}>{t("teamMembers.add.title.step1")}</div>
        <div className="wrapScrollFP">
          <div className="infoFP">
            <div className="sectionDesc">{t("teamMembers.add.desc.step1")}</div>
            <Button className="btnDocsFP" docsKey="teamMembers_add" color="docs" sizeSmall>
              button.docs
            </Button>
          </div>

          <form className="wrapFormsFP" method="post" onSubmit={this.goToNextStep}>
            <div className="formsFP">
              <Input
                className="inputFull2"
                label={t("input.label.firstName")}
                placeholder={t("input.placeholder.firstName")}
                onChange={setFormFieldValue}
                errors={formErrors.firstname}
                value={formData.firstname}
                name="firstname"
                ref={(el) => (this.firstInput = el)}
                required
              />
              <Input
                className="inputFull2"
                label={t("input.label.lastName")}
                placeholder={t("input.placeholder.firstName")}
                onChange={setFormFieldValue}
                errors={formErrors.lastname}
                value={formData.lastname}
                name="lastname"
                required
              />
              <Input
                className={cx("inputFull2", "addMarginFP")}
                label={t("input.label.email")}
                placeholder={t("input.placeholder.email")}
                onChange={setFormFieldValue}
                errors={formErrors.email_address}
                value={formData.email_address}
                name="email_address"
                type="email"
                required
              />
              <Input
                className="inputFull2"
                label={t("input.label.password")}
                onChange={setFormFieldValue}
                errors={formErrors.password}
                value={formData.password}
                name="password"
                type="password"
                required
              />
              <Input
                className="inputFull2"
                label={t("input.label.passwordConfirm")}
                onChange={setFormFieldValue}
                errors={formErrors.password_confirmation}
                value={formData.password_confirmation}
                name="password_confirmation"
                type="password"
                required
              />
              <PasswordGenerator className={cx("inputFull2", "addMarginFP")} onNewPassword={this.fillPasswordFields} />

              {isLoggedUserAdmin && (
                <CustomerSelect
                  className={cx("inputFull2", "addMarginFP")}
                  label={t("input.label.customer")}
                  value={formData.customer_code}
                  onChange={this.setCustomerCode}
                  errors={formErrors.customer_code}
                />
              )}
            </div>

            {formErrors.onForm && (
              <div className="warningMsgFP">
                <Icon className="iconWarningMsgFP" svg={warningFill} width="1rem" height="1rem" />
                <div className="textWarningMsgFP">{formErrors.onForm}</div>
              </div>
            )}

            <div className="footerFP">
              <Button color="text" type="button" onClick={this.props.backToList}>
                button.cancel
              </Button>
              <Button color="accent" type="submit" loading={isFormLoading}>
                button.continue
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
